import axios, { AxiosError } from 'axios';
import { Toast, ToastTypes } from 'plataforma-fundacao-componentes';
import { ApiErrorType } from 'services/Api';
import { languageValues } from './LanguageUtils';

export const getErrorMessages = (err: any) => {
  let errors: string[] = [];

  if (axios.isAxiosError(err)) {
    const serverError = err as AxiosError<ApiErrorType>;
    errors = serverError.response?.data?.errors ?? [];
  }

  if (!errors.length) {
    errors = [languageValues.erros.generico];
  }

  return errors;
};

export const showToastErrors = (
  showToast: (_toast: React.ComponentProps<typeof Toast>) => void,
  errors: string[],
  options: { timeout: number; showStatubar: boolean } = {
    timeout: 5000,
    showStatubar: true,
  }
) => {
  if (errors?.length) {
    errors.forEach((e) => {
      showToast({
        label: e,
        theme: ToastTypes.Error,
        ...options,
      });
    });
  }
};
